import React from 'react'
import Layout from '../layout/Layout'

export default function Contact() {
    return (
        <Layout>
            <h1>Contact</h1>

        </Layout>
    )
}
